var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrationIcon = function SvgIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#integration_icon_svg__a)",
    d: "M17.125 10.75a6.374 6.374 0 0 1 6.375 6.375V23.5h-6.375a6.375 6.375 0 1 1 0-12.75M20.5 20.5v-3.375a3.374 3.374 0 1 0-3.375 3.375zm-3.375 6H23.5v6.375a6.375 6.375 0 1 1-6.375-6.375m0 3a3.374 3.374 0 1 0 3.375 3.375V29.5zm15.75-18.75a6.375 6.375 0 1 1 0 12.75H26.5v-6.375a6.375 6.375 0 0 1 6.375-6.375m0 9.75a3.375 3.375 0 1 0-3.375-3.375V20.5zm-6.375 6h6.375a6.375 6.375 0 1 1-6.375 6.375zm3 3v3.375a3.374 3.374 0 1 0 3.375-3.375z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "integration_icon_svg__a",
    x1: 10.75,
    x2: 39.25,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335CFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF",
    stopOpacity: 0.8
  })))));
};
export default SvgIntegrationIcon;